import { render, staticRenderFns } from "./PriceDetailDialog.vue?vue&type=template&id=5f45d930&"
import script from "./PriceDetailDialog.vue?vue&type=script&lang=js&"
export * from "./PriceDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports